"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _styles = require("./styles");
const PendingIndicator = _react.default.memo(({
  width = 70,
  height = 20,
  theme,
  message = null,
  className,
  ...other
}) => {
  const isMDS = (0, _styledComponents.useTheme)().name === 'mds';
  return _react.default.createElement(_styles.SpinnerBox, (0, _extends2.default)({
    className: className
  }, other), !isMDS ? _react.default.createElement("svg", {
    viewBox: "0 0 70 20",
    width: width,
    height: height
  }, _react.default.createElement("rect", {
    width: "20",
    height: "20",
    x: "0",
    y: "0"
  }, _react.default.createElement("animate", {
    attributeName: "width",
    values: "0;20;20;20;0",
    dur: "1000ms",
    repeatCount: "indefinite"
  }), _react.default.createElement("animate", {
    attributeName: "height",
    values: "0;20;20;20;0",
    dur: "1000ms",
    repeatCount: "indefinite"
  }), _react.default.createElement("animate", {
    attributeName: "x",
    values: "10;0;0;0;10",
    dur: "1000ms",
    repeatCount: "indefinite"
  }), _react.default.createElement("animate", {
    attributeName: "y",
    values: "10;0;0;0;10",
    dur: "1000ms",
    repeatCount: "indefinite"
  })), _react.default.createElement("rect", {
    width: "20",
    height: "20",
    x: "25",
    y: "0"
  }, _react.default.createElement("animate", {
    attributeName: "width",
    values: "0;20;20;20;0",
    begin: "200ms",
    dur: "1000ms",
    repeatCount: "indefinite"
  }), _react.default.createElement("animate", {
    attributeName: "height",
    values: "0;20;20;20;0",
    begin: "200ms",
    dur: "1000ms",
    repeatCount: "indefinite"
  }), _react.default.createElement("animate", {
    attributeName: "x",
    values: "35;25;25;25;35",
    begin: "200ms",
    dur: "1000ms",
    repeatCount: "indefinite"
  }), _react.default.createElement("animate", {
    attributeName: "y",
    values: "10;0;0;0;10",
    begin: "200ms",
    dur: "1000ms",
    repeatCount: "indefinite"
  })), _react.default.createElement("rect", {
    width: "20",
    height: "20",
    x: "50"
  }, _react.default.createElement("animate", {
    attributeName: "width",
    values: "0;20;20;20;0",
    begin: "400ms",
    dur: "1000ms",
    repeatCount: "indefinite"
  }), _react.default.createElement("animate", {
    attributeName: "height",
    values: "0;20;20;20;0",
    begin: "400ms",
    dur: "1000ms",
    repeatCount: "indefinite"
  }), _react.default.createElement("animate", {
    attributeName: "x",
    values: "60;50;50;50;60",
    begin: "400ms",
    dur: "1000ms",
    repeatCount: "indefinite"
  }), _react.default.createElement("animate", {
    attributeName: "y",
    values: "10;0;0;0;10",
    begin: "400ms",
    dur: "1000ms",
    repeatCount: "indefinite"
  }))) : _react.default.createElement(_styles.CircleWrapper, {
    height: "64",
    width: "64"
  }, _react.default.createElement("circle", {
    fill: "transparent",
    strokeWidth: "6",
    r: "29",
    cx: "32",
    cy: "32"
  }), _react.default.createElement(_styles.CircleFill, {
    fill: "transparent",
    strokeWidth: "6",
    strokeDasharray: "182.212373908208 182.212373908208",
    r: "29",
    cx: "32",
    cy: "32"
  })), message && _react.default.createElement(_styles.Message, null, message));
});
var _default = exports.default = PendingIndicator;